interface Idialog {
    type: 'success' | 'error' | 'loading' | 'none'
    content?: string
    icon?: string,
    time?: number
}

import index from './Index.vue'
import useShowComponent from '@/hooks/uesShowComponent'
const { show, hide } = useShowComponent('toast', index)
const showToast = (obj: Idialog) => show(obj)
const hideToast = hide
export {
    showToast,
    hideToast
}

// import { createApp } from 'vue'
// import Toast from './Index.vue'
// // const timeout: any | null = null
// let mounteNode: HTMLElement
// interface Idialog {
//     type: 'success' | 'error' | 'loading' | 'none'
//     content?: string
//     icon?: string,
//     time?: number
// }
// let vueNode: any = null
// const showToast = (obj: Idialog) => {
//     // clearTimeout(timeout as any)
//     vueNode = createApp(Toast, {...obj})
//     mounteNode = document.createElement('div')
//     document.body.appendChild(mounteNode)
//     vueNode.mount(mounteNode)
// }
// const hideToast = () => {
//     vueNode.unmount()
//     document.body.removeChild(mounteNode)
// }
// export {
//     showToast,
//     hideToast
// }